import {
    catalogItemGalleryStackMq,
    catalogItemMediaStackMq,
} from "../../utils/compositionMediaUtils";

export const COMPOSITION_MEDIA_IMAGE_MAX_WIDTH = 730;
export const COMPOSITION_MEDIA_INFO_MIN_WIDTH = 670;
export const COMPOSITION_MEDIA_INFO_MIN_WIDTH_COMPACT = 580;
export const COMPOSITION_MEDIA_IMAGE_ASPECT_RATIO = `${COMPOSITION_MEDIA_IMAGE_MAX_WIDTH} / 716`;

export const COMPOSITION_MEDIA_GALLERY_GAP = 24;
export const COMPOSITION_MEDIA_THUMBNAILS_WIDTH = 112;
export const COMPOSITION_MEDIA_THUMBNAIL_SIZE_COMPACT = 112;
export const COMPOSITION_MEDIA_THUMBNAIL_GAP = 12;
export const COMPOSITION_MEDIA_GALLERY_MARGIN_BOTTOM = 40;

export const compositionMediaGalleryRowSx = {
    display: "flex",
    flexWrap: "nowrap",
    gap: `${COMPOSITION_MEDIA_GALLERY_GAP}px`,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    alignItems: "flex-start",
    marginBottom: `${COMPOSITION_MEDIA_GALLERY_MARGIN_BOTTOM}px`,
    [catalogItemGalleryStackMq]: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "auto",
        columnGap: "12px",
        alignItems: "start",
    },
};

export const compositionMediaStackSx = {
    display: "contents",
    [catalogItemGalleryStackMq]: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        gridColumn: 1,
        gridRow: 1,
        minWidth: 0,
        width: "100%",
    },
};

export const compositionMediaThumbnailsRailSx = {
    position: "relative",
    flex: `0 0 ${COMPOSITION_MEDIA_THUMBNAILS_WIDTH}px`,
    width: `${COMPOSITION_MEDIA_THUMBNAILS_WIDTH}px`,
    minHeight: 0,
    alignSelf: "flex-start",
    borderRadius: "16px",
    overflow: "hidden",
    [catalogItemGalleryStackMq]: {
        order: 2,
        flex: "none",
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        height: "auto",
        alignSelf: "flex-start",
        borderRadius: "16px",
    },
};

export const compositionMediaThumbnailsListSx = {
    display: "flex",
    flexDirection: "column",
    gap: `${COMPOSITION_MEDIA_THUMBNAIL_GAP}px`,
    height: "100%",
    width: "100%",
    minHeight: 0,
    overflow: "hidden",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
        display: "none",
    },
    [catalogItemGalleryStackMq]: {
        flexDirection: "row",
        alignItems: "flex-start",
        width: "100%",
        minWidth: 0,
        height: `${COMPOSITION_MEDIA_THUMBNAIL_SIZE_COMPACT}px`,
        maxHeight: `${COMPOSITION_MEDIA_THUMBNAIL_SIZE_COMPACT}px`,
        flex: "none",
        overflowX: "auto",
        overflowY: "hidden",
    },
};

export const compositionMediaThumbnailNavButtonSx = {
    position: "absolute",
    zIndex: 2,
    width: "32px",
    height: "32px",
    padding: 0,
    borderRadius: "50%",
    border: "none",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
    color: (theme) => theme.palette.text.primary,
    "&:hover": {
        backgroundColor: "#FFFFFF",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.18)",
    },
    "&.Mui-disabled": {
        opacity: 0.45,
        backgroundColor: "#FFFFFF",
    },
};

export const compositionMediaThumbnailNavButtonPrevVerticalSx = {
    top: "8px",
    left: "50%",
    transform: "translateX(-50%)",
};

export const compositionMediaThumbnailNavButtonNextVerticalSx = {
    bottom: "8px",
    left: "50%",
    transform: "translateX(-50%)",
};

export const compositionMediaThumbnailNavButtonPrevHorizontalSx = {
    left: "8px",
    top: "50%",
    transform: "translateY(-50%)",
};

export const compositionMediaThumbnailNavButtonNextHorizontalSx = {
    right: "8px",
    top: "50%",
    transform: "translateY(-50%)",
};

export const compositionMediaThumbnailItemSx = {
    width: "100%",
    height: "112px",
    boxSizing: "border-box",
    flexShrink: 0,
    borderRadius: "16px",
    [catalogItemGalleryStackMq]: {
        width: `${COMPOSITION_MEDIA_THUMBNAIL_SIZE_COMPACT}px`,
        height: `${COMPOSITION_MEDIA_THUMBNAIL_SIZE_COMPACT}px`,
    },
};

export const compositionMediaImageBoxSx = {
    position: "relative",
    flex: "1 1 0",
    minWidth: 0,
    maxWidth: COMPOSITION_MEDIA_IMAGE_MAX_WIDTH,
    aspectRatio: COMPOSITION_MEDIA_IMAGE_ASPECT_RATIO,
    alignSelf: "flex-start",
    borderRadius: "16px",
    overflow: "hidden",
    [catalogItemGalleryStackMq]: {
        order: 1,
        flex: "0 0 auto",
        alignSelf: "stretch",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
        border: (theme) => `1px solid ${theme.palette.primary.stroke}`,
    },
};

export const compositionMediaInfoColumnSx = {
    flex: "1 1 0",
    minWidth: 0,
    maxWidth: COMPOSITION_MEDIA_IMAGE_MAX_WIDTH,
    display: "flex",
    gap: "24px",
    flexDirection: "column",
    [catalogItemMediaStackMq]: {
        gap: "16px",
    },
    [catalogItemGalleryStackMq]: {
        gridColumn: 2,
        gridRow: 1,
        alignSelf: "start",
        maxWidth: "none",
        minHeight: 0,
    },
};

export const compositionMediaInfoCardSx = {
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    border: (theme) => `1px solid ${theme.palette.primary.stroke}`,
    borderRadius: "16px",
    overflow: "hidden",
    flex: "0 0 auto",
    [catalogItemGalleryStackMq]: {
        flex: "0 0 auto",
    },
};

/** Fixed-height card beside gallery: flex column so inner panel scrolls. */
export const compositionMediaInfoCardMeasuredSx = {
    flex: "1 1 auto",
    minHeight: 0,
    overflow: "hidden",
};

export const compositionMediaModulePanelInCardSx = {
    border: "none",
    borderRadius: 0,
    maxWidth: "none",
    width: "100%",
    flex: "1 1 auto",
    minHeight: 0,
    maxHeight: "100%",
    overflowY: "auto",
};
